import { filesApi } from '@/api/files.api';

export async function uploadLeaveAttachment(file: File | null | undefined): Promise<string | undefined> {
  if (!file) return undefined;
  const uploaded = await filesApi.uploadDocument(file);
  return uploaded.url ?? uploaded.fileUrl;
}
